import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import { ZOOM_ICON } from "js/config.jsx";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import DOCKER_ADVANCED_SCREENSHOT from "resources/img/docker-advanced-screenshot.png";


export default React.createClass({
  displayName: "zoom-browser-docker-help",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {

    return {
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container zoom_docker">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2>FaceTec Browser Integration Guide</h2>
                </div>
                <p>These steps walk you through the initial integration of the FaceTec Browser SDK into your application.</p>
                <hr/>
              </section>

              <section id="FaceTec Device SDK: Features & Options">
                <h3>Getting Started</h3>
                <p>These instructions will get the FaceTec Browser SDK running on your local dev machine.  The steps are the same for remote machines.</p>
                <br/>

                <h3>Prerequisites</h3>
                <p>You will need to download, and install <a href="https://www.docker.com/" target="_blank">Docker</a></p>

                <br/>

                <h3>Check out our ~2 minute video walkthrough:</h3>
                <p className="small">Note: This video also shows steps to run the FaceTec Server SDK (Dockerized).   This is not required for initial testing against the FaceTec Testing API.</p>
                <p></p>
                <div className="embed-responsive embed-responsive-16by9" >
                  <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/BFBH8Obq7Ag" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
                <p></p>
                <p></p>

                <h3>Building the Docker images, and running the Docker container</h3>
                <p>To run, you simply need to cd to the extracted directory and run the command below (inserting your Key  information).</p>
                <div className="highlight">
                    # cd to extracted directory<br/>
                    cd /path/to/extracted<br/><br/>

                    # Build and run the FaceTec Browser.  Make sure to replace your SDK Keys in the following command.<br/>
                    # --build-arg ZoomServerBaseURL=Change this to your ZoomServer deployment URL. <br/>
                    docker-compose build --build-arg DeviceLicenseKeyIdentifier=YOUR_DEVICE_LICENSE_KEY --build-arg ZoomServerBaseURL=https://api.zoomauth.com/api/v2/biometrics --build-arg PathToPublicFaceMapEncryptionKey=./keys/PublicFaceMapEncryptionKey.pub && docker-compose up<br/><br/>
                </div>
                <br/>

                <h3>Building the Docker images with Production Key</h3>
                <p>To run, you simply need to cd to the extracted directory and run the command below (inserting your Key  information).</p>
                <div className="highlight">
                    # cd to extracted directory<br/>
                    cd /path/to/extracted<br/><br/>

                    # Build and run the FaceTec Browser.  Make sure to replace your SDK Keys in the following command.<br/>
                    # --build-arg ZoomServerBaseURL=Change this to your ZoomServer deployment URL. <br/>
                    docker-compose build --build-arg DeviceLicenseKeyIdentifier=YOUR_DEVICE_LICENSE_KEY --build-arg ZoomServerBaseURL=https://api.zoomauth.com/api/v2/biometrics --build-arg PathToPublicFaceMapEncryptionKey=./keys/PublicFaceMapEncryptionKey.pub --build-arg PathToSFTPLicenseText=./keys/FaceTec_Browser_SDK_License.txt && docker-compose up<br/><br/>
                </div>
                <br/>
                <h3>Build Arguments</h3>
                <p>This is the list of possible build arguments that can passed in via docker</p>

                <p><strong>DeviceLicenseKeyIdentifier</strong></p>
                <p>Required parameter -- visit <Link to="/account">https://dev.facetec.com/zoomsdk/#/account</Link> to get your Key </p>
                <div className="highlight">DeviceLicenseKeyIdentifier=YOUR_ACCOUNT_DEVICE_LICENSE_KEY<br/></div>

                <p><strong>ZoomServerBaseURL</strong></p>
                <p>Your FaceTec Server SDK Deployment URL</p>
                <div className="highlight">ZoomServerBaseURL=https://api.zoomauth.com/api/v2/biometrics<br/></div>

                <p><strong>PathToPublicFaceMapEncryptionKey</strong></p>
                <p>Public Key based off your private key used for FaceMap encryption. For more information on generating your own public key, please visit <Link to="/licensing-and-encryption-keys">https://dev.facetec.com/zoomsdk/#/licensing-and-encryption-keys</Link></p>
                <div className="highlight">PathToPublicFaceMapEncryptionKey=./keys/PublicFaceMapEncryptionKey.pub<br/></div>

                <p><strong>PathToSFTPLicenseText</strong></p>
                <p>Initialize FaceTec utilizing SFTP Key. For more information on your SFTP Key please visit <Link to="/licensing-and-encryption-keys">https://dev.facetec.com/zoomsdk/#/licensing-and-encryption-keys</Link></p>
                <div className="highlight">PathToSFTPLicenseText=./keys/FaceTec_Browser_SDK_License.txt<br/></div>

                <br/>
              </section>

              <SDKSidebar menuType="main" title="FaceTec Browser Docker Help"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-browser-docker-help.jsx